import { useNavigate } from 'react-router-dom';

const PILLARS = [
  {
    n: '1',
    statClass: 'stat-value',
    iconPill: 'icon-pill',
    iconColor: 'text-teal-500',
    icon: 'ri-robot-2-fill',
    title: 'ChatGPT Ads',
    description:
      'Get your business recommended when potential customers ask ChatGPT, Claude, or Perplexity for service recommendations in your area.',
    features: ['AI assistant visibility', 'Conversational placements', 'Intent-based targeting', 'Performance tracking'],
    check: 'text-teal-500',
    link: 'text-teal-600 hover:text-teal-500',
    path: '/chatgpt-ads',
  },
  {
    n: '2',
    statClass: 'stat-value-orange',
    iconPill: 'icon-pill-orange',
    iconColor: 'text-orange-500',
    icon: 'ri-search-eye-line',
    title: 'Generative Engine Optimization (GEO)',
    description:
      'Dominate AI-powered search results. When AI engines research your industry, your business appears first with compelling, accurate information.',
    features: ['AI search optimization', 'Schema markup implementation', 'Content optimization', 'Visibility tracking'],
    check: 'text-orange-500',
    link: 'text-orange-600 hover:text-orange-500',
    path: '/geo',
  },
  {
    n: '3',
    statClass: 'stat-value',
    iconPill: 'icon-pill',
    iconColor: 'text-teal-500',
    icon: 'ri-phone-fill',
    title: 'Voice AI Agents',
    description:
      'Never miss a lead again. Our AI answers every call 24/7, qualifies prospects, books appointments, and integrates with your CRM.',
    features: ['24/7 call answering', 'Lead qualification', 'Appointment booking', 'CRM integration'],
    check: 'text-teal-500',
    link: 'text-teal-600 hover:text-teal-500',
    path: '/voice-ai',
  },
];

export default function ThreePillars() {
  const navigate = useNavigate();

  return (
    <section id="pillars" className="relative py-28 overflow-hidden bg-white grid-bg">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at 15% 15%, rgba(20,184,166,0.18), transparent 55%), radial-gradient(ellipse at 85% 85%, rgba(249,115,22,0.12), transparent 55%)',
        }}
      ></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="eyebrow reveal">The Three Pillars of AI Marketing</div>
          <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] reveal">
            Put Yourself Where<br />Customers Are Looking.
          </h2>
          <p className="mt-6 text-slate-600 font-body font-light text-base md:text-lg reveal">
            While traditional marketing fights for attention, AI marketing puts you directly in front
            of customers actively seeking your services.
          </p>
        </div>

        {PILLARS.map((p) => (
          <div
            key={p.n}
            className="grid md:grid-cols-[auto_1fr] gap-6 md:gap-10 items-start mb-16 last:mb-0 reveal"
          >
            <div className={`h-display text-6xl md:text-8xl ${p.statClass} leading-none`}>{p.n}</div>
            <div className="glass rounded-3xl p-7 md:p-10">
              <div className="flex items-center gap-3 mb-4">
                <div className={p.iconPill}>
                  <i className={`${p.icon} ${p.iconColor}`}></i>
                </div>
                <h3 className="h-display text-3xl md:text-4xl leading-tight">{p.title}</h3>
              </div>
              <p className="text-slate-600 font-body font-light text-base leading-relaxed">
                {p.description}
              </p>
              <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                {p.features.map((f) => (
                  <li key={f} className="flex gap-2 text-sm text-slate-700 font-body">
                    <i className={`ri-checkbox-circle-fill ${p.check} mt-0.5`}></i>
                    {f}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => navigate(p.path)}
                className={`mt-6 inline-flex items-center gap-2 text-sm font-body font-semibold ${p.link}`}
              >
                Learn More <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
